export const createApiHeadersGetter = (getAuthToken: () => Promise<string | null>) => {
  return async (): Promise<HeadersInit> => {
    const token = await getAuthToken();
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    
    const headers = {
      'X-User-Id': userData?.["userId"],
      'X-User-Email': userData?.["email"],
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };
    
    return headers;
  };
};